<template>
    <div>
        <section v-if="isMobile" :class="section_class">
            <v-layout fill-height align-center row wrap>
                <v-flex xs12 sm12>
                    <section-data :data="data"></section-data>
                </v-flex>
                <v-flex xs12 sm12>
                    <images-card v-if="data.image" :section_id="section_id" :image="data.image" :section_pos="section_pos"></images-card>
                </v-flex>
            </v-layout>
        </section>
        <section v-if="!isMobile" :class="section_class">
            <v-layout fill-height align-center row wrap>
                <v-flex xs12 sm6 v-if="image_location=='left'">
                    <images-card v-if="data.image" :section_id="section_id" :image="data.image" :section_pos="section_pos" location='left'></images-card>
                </v-flex>
                <v-flex xs12 sm6>
                    <section-data :data="data"></section-data>
                </v-flex>
                <v-flex xs12 sm6 v-if="image_location=='right'">
                    <images-card v-if="data.image" :section_id="section_id" :image="data.image" :section_pos="section_pos" location='right'></images-card>
                </v-flex>
            </v-layout>
        </section>
    </div>
</template>
<script>
export default {
    data() {
        return {
            section_pos: null
        }
    },
    components: {
        'section-data': () => import('@/components/SectionData'),
        'images-card': () => import('@/components/ImageCard'),
    },
    methods: {},
    props: ['data', 'image_location', 'section_class', 'section_id'],
    computed: {
        isMobile() {
            return window.innerWidth < 600
        }
    },
    mounted() {
        this.section_pos = document.getElementById(this.section_id).offsetTop
    }
}
</script>